import script from "./Tasks.vue?vue&type=script&setup=true&lang=ts"
export * from "./Tasks.vue?vue&type=script&setup=true&lang=ts"

import "./Tasks.vue?vue&type=style&index=0&id=56453f8c&lang=scss"

const __exports__ = script;

export default __exports__